__turbopack_context__.v({
  "large": "PhoneInput-module-scss-module__8XzNyq__large",
  "middle": "PhoneInput-module-scss-module__8XzNyq__middle",
  "phoneInput": "PhoneInput-module-scss-module__8XzNyq__phoneInput",
  "phoneInputContainer": "PhoneInput-module-scss-module__8XzNyq__phoneInputContainer",
  "phoneInputCountrySelect": "PhoneInput-module-scss-module__8XzNyq__phoneInputCountrySelect",
  "placeholderColor": "PhoneInput-module-scss-module__8XzNyq__placeholderColor",
});
